import React from 'react';
import { B } from '../constants';

const CROP_MODES = [
  {
    id: 'letterbox',
    label: 'Letterbox',
    icon: '⬛',
    desc: 'Fills frame with black bars — preserves full video',
  },
  {
    id: 'crop',
    label: 'Crop to Fit',
    icon: '✂️',
    desc: 'Fills entire frame by cropping edges — no black bars',
  },
  {
    id: 'smart_crop',
    label: 'Smart Crop',
    icon: '🎯',
    desc: 'Intelligently centers on the most important content',
  },
];

const RATIO_LABELS = {
  '9:16': { icon: '📱', label: '9:16 Portrait' },
  '1:1': { icon: '📐', label: '1:1 Square' },
  '16:9': { icon: '🖥️', label: '16:9 Landscape' },
};

export default function AspectRatioSelector({ videoAspectRatio, value, cropMode, onChangeRatio, onChangeCropMode }) {
  const platformRatios = ['9:16', '1:1', '16:9'];

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: B.muted, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>
        Aspect Ratio — {videoAspectRatio || 'auto'}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12 }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: B.muted, marginBottom: 4 }}>Target Ratio</div>
        <div style={{ display: 'flex', gap: 6 }}>
          {platformRatios.map(ratio => (
            <button key={ratio} onClick={() => onChangeRatio?.(ratio)}
              style={{
                flex: 1, padding: '8px 6px', borderRadius: 8, border: `2px solid ${value === ratio ? B.forest : '#e5e0d8'}`,
                background: value === ratio ? 'rgba(26,107,74,0.08)' : 'white', cursor: 'pointer', textAlign: 'center',
                fontFamily: "'Montserrat',sans-serif", fontSize: 11, fontWeight: 600, color: value === ratio ? B.forest : B.muted,
                transition: 'all 0.15s',
              }}>
              <div style={{ fontSize: 16, marginBottom: 2 }}>{RATIO_LABELS[ratio]?.icon || '🔲'}</div>
              <div>{RATIO_LABELS[ratio]?.label || ratio}</div>
            </button>
          ))}
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: B.muted, marginBottom: 4 }}>Crop Mode</div>
        {CROP_MODES.map(mode => (
          <button key={mode.id} onClick={() => onChangeCropMode?.(mode.id)}
            style={{
              display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderRadius: 10,
              border: `2px solid ${cropMode === mode.id ? B.forest : '#e5e0d8'}`,
              background: cropMode === mode.id ? 'rgba(26,107,74,0.08)' : 'white', cursor: 'pointer', width: '100%', textAlign: 'left',
              transition: 'all 0.15s',
            }}>
            <span style={{ fontSize: 20 }}>{mode.icon}</span>
            <div>
              <div style={{ fontWeight: 600, fontSize: 13, color: cropMode === mode.id ? B.forest : B.night }}>{mode.label}</div>
              <div style={{ fontSize: 11, color: B.muted }}>{mode.desc}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
